import { Component, Input } from '@angular/core';
import { PriceRegion, PriceSegment, ProductPriceCell, ProductPriceOverviewRow, ProductRegionOverview } from '@/app/shared/interfaces/product-price-overview.interface';
import {
  REGIONS, REGION_LABELS, SEGMENTS, SEGMENT_LABELS, formatNumber, formatPrice, limitedText, notSellableLabel, priceCell, regionOf, stockStatusLabel
} from '@/app/shared/helpers/product-price.helpers';

// Phần mở rộng của một dòng ở /product-v2 và ở báo cáo Hàng cần xử lý: ma trận giá 3 nhóm khách x 2 miền (W1, W2, W2 Limit, giá đang bán) và "thông tin phụ sản phẩm" (ProductMeta) theo miền.
@Component({
  selector: 'app-product-price-matrix',
  templateUrl: './product-price-matrix.component.html',
  styleUrls: ['./product-price-matrix.component.scss']
})
export class ProductPriceMatrixComponent {
  @Input() row!: ProductPriceOverviewRow;
  // Miền hiện ra; mặc định cả hai (trang /product-v2), báo cáo Hàng cần xử lý chỉ hiện miền của dòng.
  @Input() regions: PriceRegion[] = REGIONS;

  public readonly segments = SEGMENTS;
  public readonly segmentLabels = SEGMENT_LABELS;
  public readonly regionLabels = REGION_LABELS;

  public price = formatPrice;
  public num = formatNumber;
  public statusLabel = stockStatusLabel;
  public limitText = limitedText;
  public reasonLabel = notSellableLabel;

  public cell(segment: PriceSegment, region: PriceRegion): ProductPriceCell | undefined {
    return priceCell(this.row, segment, region);
  }

  public regionInfo(region: PriceRegion): ProductRegionOverview | undefined {
    return regionOf(this.row, region);
  }

  // Giới hạn đè theo role chỉ có khi cấu hình OrderQuantityLimitByRole có SKU này; "MV: 5/đơn, 20/ngày".
  public roleLimitText(region: ProductRegionOverview): string {
    return region.roleOrderLimits
      .map(l => `${l.segment}: ${l.perOrder ?? '—'}/đơn, ${l.perDay ?? '—'}/ngày`)
      .join('; ');
  }

  public limitUnlimited(value: number): string {
    return value > 0 ? formatNumber(value) : 'Không giới hạn';
  }
}
